/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./not-found.vue.js?vue&type=template&id=2c745239!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./not-found.vue?vue&type=template&id=2c745239"
var script = {}
import style0 from "./not-found.vue.postcss?vue&type=style&index=0&id=2c745239&prod&lang=postcss&module=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./not-found.vue?vue&type=style&index=0&id=2c745239&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports